/* eslint-disable max-len */
/* eslint-disable object-property-newline */
import { Content, Flex, Pane } from '@leverege/ui-elements';
import { TitleBar, Toolbar } from '@leverege/ui-plugin';
import React from 'react';
import SplitPane from 'split-pane-react';
import LayoutModel from "../../dataViewers/layout/LayoutModel.js";
import { dvProps, rdvm, rhdv } from "../../dataViewers/Util.js";
import Blocker from "../../views/blocker/Blocker.js";
import ProgressBar from "../../views/ProgressBar.js";
import AbstractGroupScreen, { connectChild } from "./AbstractGroupScreen.js"; // import SearchBar from './search/DesktopSearchBar'
import S from './DesktopGroupScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class DesktopGroupScreen extends AbstractGroupScreen {
  constructor(props) {
    super(props);
    this.toolbarMatchContext = {
      ...this.matchContext,
      use: 'actionBar'
    };
    this.layoutToolbarMatchContext = {
      ...this.matchContext,
      use: 'layoutActionBar'
    };
    this.filterMatchContext = {
      ...this.matchContext,
      use: 'sortFilterBar'
    };
    this.filterRightMatchContext = {
      ...this.matchContext,
      use: 'sortFilterBarRight'
    };
    const {
      settingsPath
    } = props;
    const splitPaneSizes = localStorage.getItem(`${settingsPath}.splitPaneSizes`);
    this.state = {
      splitPaneSizes: splitPaneSizes ? JSON.parse(splitPaneSizes) : ['50%', '50%']
    };
  }
  onChangeSplitSize = sizes => {
    const {
      settingsPath
    } = this.props;
    localStorage.setItem(`${settingsPath}.splitPaneSizes`, JSON.stringify(sizes));
    this.setState({
      splitPaneSizes: sizes
    });
  };
  render() {
    const {
      filters,
      page,
      perPage
    } = this.getQueryOptions();
    return /*#__PURE__*/_jsx(Blocker, {
      hooks: [{
        sort: 1000,
        execute: () => {
          return this.initialLoad;
        }
      }],
      matchContext: this.matchContext,
      context: {
        ...this.props,
        onFilterChange: this.onUpdateFilter,
        filters,
        page,
        perPage
      },
      render: this.renderChildren
    });
  }
  renderChildren = () => {
    const {
      modifiedLayout,
      splitPaneSizes
    } = this.state;
    const {
      settings,
      items,
      loading
    } = this.props;
    const currLayout = modifiedLayout || settings || {};
    const {
      layout: layoutAlign = 'vh',
      main1,
      main2,
      aux1,
      aux2,
      aux3,
      aux4
    } = currLayout;
    const showFilterBar = LayoutModel.getShowFilterBar(currLayout);
    const name = this.getTitle();
    const icon = this.getIcon();
    const mainVertical = layoutAlign[1] === 'v';
    const {
      page,
      perPage
    } = this.getQueryOptions();
    const dataItems = this.cache.calc('items', this.createDataItems, items, page, perPage);
    const hiddenDataViewers = this.getHiddenDataViewers(this.matchContext);
    this.paginator.setData(dataItems);
    const cxt = this.getContext();
    const dvp = this.getDataViewerProps();
    const gridTemplateAreas = this.cache.calc('layout', LayoutModel.createGridTemplate, currLayout);
    const cAux1 = rdvm(aux1, dvp, {
      settingsData: 'setAux1Settings',
      vertical: false
    });
    const cAux2 = rdvm(aux2, dvp, {
      settingsData: 'setAux2Settings',
      vertical: false
    });
    const cAux3 = rdvm(aux3, dvp, {
      settingsData: 'setAux3Settings',
      vertical: true
    });
    const cAux4 = rdvm(aux4, dvp, {
      settingsData: 'setAux4Settings',
      vertical: true
    });
    const cMain1 = rdvm(main1, dvp, {
      settingsData: 'setMain1Settings'
    });
    const cMain2 = rdvm(main2, dvp, {
      settingsData: 'setMain2Settings'
    });
    const hasSplit = cMain1 && cMain2;
    const searchViewers = this.dataViewers.getFor('search', true);
    const SearchBar = searchViewers?.length > 0 ? searchViewers[0]?.component : null;
    return /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsxs(Content.Header, {
        children: [/*#__PURE__*/_jsxs(TitleBar, {
          variant: "screenTitle",
          title: name,
          icon: icon,
          children: [/*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBar",
            hasContextMenu: true,
            prefer: "icon",
            matchContext: this.toolbarMatchContext,
            context: cxt
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "rowM",
            align: "center",
            children: [/*#__PURE__*/_jsx(Toolbar, {
              variant: "layoutActionBar|actionBar",
              prefer: "icon",
              matchContext: this.layoutToolbarMatchContext,
              mustMatchContext: {
                use: 'layoutActionBar'
              },
              context: cxt
            }), SearchBar ? /*#__PURE__*/_jsx(SearchBar, {
              ...dvProps({
                type: 'freeTextSearch'
              }, dvp)
            }) : null]
          })]
        }), showFilterBar && /*#__PURE__*/_jsxs(Pane, {
          variant: "sortFilterBar",
          layout: "flex:rowSpaceBetweenCenter",
          children: [/*#__PURE__*/_jsx(Toolbar, {
            variant: "sortFilterToolbar",
            prefer: "icon",
            matchContext: this.filterMatchContext,
            context: cxt
          }), /*#__PURE__*/_jsx(Toolbar, {
            variant: "sortFilterToolbarRight",
            prefer: "icon",
            matchContext: this.filterRightMatchContext,
            context: cxt
          })]
        }), /*#__PURE__*/_jsx(ProgressBar, {
          loading: loading
        })]
      }), /*#__PURE__*/_jsxs(Content.Area, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: S.grid,
          style: {
            '--grid': gridTemplateAreas
          },
          children: [cAux1 && /*#__PURE__*/_jsx("div", {
            className: S.aux1,
            children: cAux1
          }, "aux1"), cAux2 && /*#__PURE__*/_jsx("div", {
            className: S.aux2,
            children: cAux2
          }, "aux2"), cAux3 && /*#__PURE__*/_jsx("div", {
            className: S.aux3,
            children: cAux3
          }, "aux3"), cAux4 && /*#__PURE__*/_jsx("div", {
            className: S.aux4,
            children: cAux4
          }, "aux4"), /*#__PURE__*/_jsx("div", {
            className: S.main,
            children: /*#__PURE__*/_jsxs(SplitPane, {
              allowResize: hasSplit,
              resizerSize: hasSplit ? 4 : 0,
              sizes: hasSplit ? splitPaneSizes : [main1 ? '100%' : 0, main2 ? '100%' : 0],
              onChange: this.onChangeSplitSize,
              split: !mainVertical ? 'vertical' : 'horizontal',
              children: [cMain1 || /*#__PURE__*/_jsx("div", {}), cMain2 || /*#__PURE__*/_jsx("div", {})]
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: S.hiddenDataViewers,
          children: hiddenDataViewers.map(dataViewer => rhdv(dataViewer, dvp))
        })]
      })]
    });
  };
}
export default connectChild(DesktopGroupScreen, {
  clientType: 'DesktopGroupScreen'
}, LayoutModel);